module.exports = __webpack_public_path__ + "static/media/tree_team_btn.4079f9ac.svg";